export type DashboardApp =
  | "accesspoint"
  | "perkpoint"
  | "gamepoint"
  | "xpandpoint"
  | "rewardpoint"
  | "giftcard"
  | "offers";

/** Legacy root paths that still render under Access Point navigation. */
const LEGACY_ACCESS_POINT_PREFIXES = [
  "/dashboard",
  "/programs",
  "/merchants",
  "/transactions",
  "/invoices",
  "/analytics",
  "/jobs",
  "/clients",
  "/users",
  "/settings",
];

export function getAppFromPathname(pathname: string): DashboardApp | null {
  if (pathname === "/" || pathname.startsWith("/accesspoint")) {
    return "accesspoint";
  }
  if (pathname.startsWith("/gamepoint")) return "gamepoint";
  if (pathname.startsWith("/perkpoint")) return "perkpoint";
  if (pathname.startsWith("/xpandpoint")) return "xpandpoint";
  if (pathname.startsWith("/rewardpoint")) return "rewardpoint";
  if (pathname.startsWith("/giftcard")) return "giftcard";
  if (pathname.startsWith("/offers")) return "offers";

  if (
    LEGACY_ACCESS_POINT_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  ) {
    return "accesspoint";
  }

  return null;
}

export function isKnownAppRoute(pathname: string): boolean {
  return getAppFromPathname(pathname) !== null;
}
